import React from 'react';
import {useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';

import { REGISTERED_PAGE_URL, VERIFICATION_PAGE_URL } from '../../../constants';

import UserPasswordUI from '../../../stories/components/Onboarding/UserPassword/UserPasswordUI';
import UpdatePasswordUI from '../../../stories/components/UpdatePassword/UpdatePasswordUI';


import * as actions from '../../../store/actions/index';
import { tokenSelector, mobileSelector, nextLoader, tncLinkSelector, errorSelector, verify_mmt_passwordSelector, account_existsSelector } from '../../../store/selectors';
import {removeItem} from '../../../../../../common/client-side-storage/src/client-side-storage.web';

const UserPassword = () => {

    const history = useHistory();

    const dispatch = useDispatch();

    const [showForgotPwdForm, setShowForgotPwdForm] = React.useState(false);
    const [tokenApiMessage, setTokenApiMessage] = React.useState('');
    const [updatePwdApiErrorMessage, setUpdatePwdApiErrorMessage] = React.useState('');
    const [forgotPasswordLoader, setForgotPasswordLoader] = React.useState(false);

    const token = useSelector(tokenSelector);
    const setLoader = useSelector(nextLoader);
    const mobile = useSelector(mobileSelector);
    const terms = useSelector(tncLinkSelector);
    const error = useSelector(errorSelector);
    const account_exists = useSelector(account_existsSelector);
    const verify_mmt_password = useSelector(verify_mmt_passwordSelector);

    const successCallback = (url, status, campaign) => {

        // campaign tracker gtag event call
        // check campaign presence && if the function added in the base page is present to be sure, before calling
        // short ciruit if not present, and call the function if all conditions are met
        campaign !=='' && window.gtag_report_conversion !== undefined && window.gtag_report_conversion(window.location.href);
        // Remove the local storage values, once the onboarding is done
        removeItem("ref")
        removeItem("cmp")
        removeItem("token")
        if (url !== '') {
          window.open(url, '_self');
        } else {
          if (status === 'approved') {
            history.push(`${REGISTERED_PAGE_URL}`);
          } else if (status === 'manual') {
            history.push(`${VERIFICATION_PAGE_URL}`);
          }
        }
    }

    const setPassword = (data) => {
        let fd = new FormData();
        if(!account_exists || (account_exists && verify_mmt_password)) {
          fd.append('password', data.password);
        }
        if(!account_exists) {
          fd.append('confirm_password', data.confirm_pass);
        }
        fd.append('token', token);
        fd.append('agreed_time', data.userConsent);
        dispatch(actions.submitPass(fd, successCallback))
    }


    // UPDATE PASSWORD
    const updatePassSuccessCallback = (response: any) => {
      setShowForgotPwdForm(false);
      // to show the updated message on login form for successfull pwd change after he comes back from update pwd page.
      setTokenApiMessage(response.message);
    }
    const updatePassErrorCallback = (data) => {setUpdatePwdApiErrorMessage(data.message)}
    const updatePassword = (data) => {
      let fd = new FormData();
      fd.append('password', data.password);
      fd.append('confirm_password', data.confirm_pass);
      fd.append('token', token);
      fd.append('otp', data.mobile_otp);
      fd.append('onboarding', 'true');  // to get the different message from the api (As the same API is used in login flow.)
      dispatch(actions.updatePass(fd, updatePassSuccessCallback, updatePassErrorCallback))
    }
    const resendUpdatePwdOtp = () => {
      setUpdatePwdApiErrorMessage('');
      dispatch(actions.getPassTokenOrResendToken(token, getTokenSuccessCallback, getTokenErrorCallback, 'resend'))
    }

    // GET FORGOT PASSWORD TOKEN
    const getTokenSuccessCallback = (forgotPwdApiTokenData) => {
      setForgotPasswordLoader(false)
      setShowForgotPwdForm(true);
      setTokenApiMessage(forgotPwdApiTokenData.message);
    }
    const getTokenErrorCallback = (error) => {
      setForgotPasswordLoader(false)
      setTokenApiMessage(error.message);
    } 
    const onforgotPwdClickHandler = () => {
      setForgotPasswordLoader(true)
      setUpdatePwdApiErrorMessage('')
      dispatch(actions.getPassTokenOrResendToken(mobile, getTokenSuccessCallback, getTokenErrorCallback, 'forgotPwdOnboarding'))
    }
  
    return (
      <>
      {
        !showForgotPwdForm ? (
          <UserPasswordUI
            apiError={error}
            setPassword={data => setPassword(data)}
            mobileUser={mobile}
            setLoader={setLoader}
            onforgotPwdClickHandler={onforgotPwdClickHandler}
            tokenApiMessage={tokenApiMessage}
            forgotPasswordLoader={forgotPasswordLoader}
        />
        ) : (
          <UpdatePasswordUI 
            apiError={updatePwdApiErrorMessage}
            resendOTP={resendUpdatePwdOtp}
            setPassword={(data)=>updatePassword(data)}
            isLoading={false}
            loginApiMessage={tokenApiMessage}
            mobileUser={mobile}
            //  setLoader={setLoader}
          />
        )
      }
      </>
    )
}

export default UserPassword;
